import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClipBoardService } from 'src/app/services/clipboard.service';
import { ServerService } from 'src/app/services/server.service';
import * as WebDataRocks from 'webdatarocks';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-project-wise-source-dashboard',
  templateUrl: './project-wise-source-dashboard.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./project-wise-source-dashboard.component.scss']
})
export class ProjectWiseSourceDashboardComponent implements OnInit {

  @ViewChild('pivotContainer', { static: false }) pivotContainer: ElementRef;
  @ViewChild('weekpivotContainer', { static: false }) weekpivotContainer: ElementRef;
  @ViewChild('utmpivotContainer', { static: false }) utmpivotContainer: ElementRef;

  authToken = localStorage.getItem("token");

  detailedTable: any;
  filterForm: FormGroup;
  weekDay: any;
  noFilter = true;
  weekRealJson: any = [];;
  isFilter: boolean = false;
  btnStatus: boolean = false;
  projectByUsers: any;
  demoWeekJSON: any;
  week: any;
  myDateRangePickerOptions = {
    dateFormat: 'dd-mm-yyyy'
  };
  // dateRange: any = { "beginDate": { "year": 2023, "month": 4, "day": 1 }, "endDate": { "year": 2023, "month": 4, "day": 30 } }
  dateRange: any = ""
  load = false;
  clients: any[] = []
  selectedClients: any[] = []

  projects: any[] = [];
  shouldRenderSecondElement = false;
  shouldRenderProjectElement = false;
  shouldRenderThirdElement = false;
  selectedProjects: any[] = []
  realJson: any = [];
  demoJSON: any = [];

  fbCampaign: any;
  googleCampaign:any
  utmCampaign:any;
  reports:any;

  users: any[] = []
  selectedusers: any[] = []
  tilesCount:any;
  leadStatusList: any[] = [
  ]
  selectedLeadStatusList: any[] = []
  teleCallerDetails: any;

  filterText:any;

  //Count variable

  totalLeadCount:any;
  totalFreshCount:any;
  totalColdCount:any;
  totalOtherCount:any;
  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private _fb: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.filterText =  "Lead Creation Date Range"; 
   
  }

  ngOnInit() {

    this.setFilter()
  
    this.getProjects()


    this.filterForm.get('dateRange').valueChanges.subscribe(res=>{
      if(res==null){
        //this.filterForm.reset()
        this.noFilter = true;
        this.isFilter = false;
        this.load = false
      }
    })

  }
  ngAfterViewInit() {
    // debugger
    // this.teleCallerReport()

  }
  campaignReport() {
    let body = {
      // "date_range": ["2018-10-10", "2023-08-16"]

    }
    if (this.filterText == 'Lead Creation Date Range') {
      body["date_range"] = [this.filterForm.value.dateRangeVendorModified.beginDate.year + '-' + this.filterForm.value.dateRangeVendorModified.beginDate.month + '-' + this.filterForm.value.dateRangeVendorModified.beginDate.day, this.filterForm.value.dateRangeVendorModified.endDate.year + '-' + this.filterForm.value.dateRangeVendorModified.endDate.month + '-' + this.filterForm.value.dateRangeVendorModified.endDate.day]
      // body["date_range"] = [this.filterForm.value['dateRange'].formatted.split(" - ")[0], this.filterForm.value['dateRange'].formatted.split(" - ")[1]];
      // body["date_range"] = [this.filterForm.value.dateRange.beginDate.year + '-' + this.filterForm.value.dateRange.beginDate.month + '-' + this.filterForm.value.dateRange.beginDate.day, this.filterForm.value.dateRange.endDate.year + '-' + this.filterForm.value.dateRange.endDate.month + '-' + this.filterForm.value.dateRange.endDate.day]
    }

    if (this.filterForm.value['project']) {
      body['project_ids'] = [this.filterForm.value['project']['id']]
    }
    if (this.filterText == 'Last Vendor Modified Date Range') {
      // body["date_range"] = [this.filterForm.value['dateRange'].formatted.split(" - ")[0], this.filterForm.value['dateRange'].formatted.split(" - ")[1]];
      body["last_vendor_status_updated_at_range"] = [this.filterForm.value.dateRangeVendorModified.beginDate.year + '-' + this.filterForm.value.dateRangeVendorModified.beginDate.month + '-' + this.filterForm.value.dateRangeVendorModified.beginDate.day, this.filterForm.value.dateRangeVendorModified.endDate.year + '-' + this.filterForm.value.dateRangeVendorModified.endDate.month + '-' + this.filterForm.value.dateRangeVendorModified.endDate.day]
    }
    
    // console.log(body)

    this.serverService.getProjectWiseSourceReport(body, this.authToken).subscribe((data) => {
     
      // console.log(data)
      this.tilesCount = data.campaign_lead_state_report;
      // console.log(data)
      // console.log(this.tilesCount)
      this.fbCampaign = data.facebook_campaign_lead_status_report;
      // console.log(this.fbCampaign)
      this.googleCampaign = data.google_campaign_lead_status_report;
      this.utmCampaign = data.utm_based_lead_status_report;

      //Count variable
    
      this.totalLeadCount = this.tilesCount["total_leads"]?this.tilesCount["total_leads"]:0;
      this.totalFreshCount = this.tilesCount["fresh"]["total_leads"] != undefined || this.tilesCount["fresh"]["total_leads"] != null ?this.tilesCount["fresh"]["total_leads"]:0;
      this.totalColdCount = this.tilesCount["cold"]["total_leads"] != undefined || this.tilesCount["cold"]["total_leads"] != null ?this.tilesCount["cold"]["total_leads"]:0;
      this.totalOtherCount = this.tilesCount["others"]["total_leads"] != undefined || this.tilesCount["others"]["total_leads"] != null ?this.tilesCount["others"]["total_leads"]:0
    
      ////////// Transformation of Data/////////////////////////////////////////////////////////////////////

      // Facebook Campaign
      const transformedFBCampaignData: any[] = this.fbCampaign.map((item) => ({
        "Campaign Name": item.fb_campaign_name,
        "FB Adset Name": item.fb_adset_name,
        "FB AD Name":item.fb_ad_name,
  
        "Total Leads":item.lead_count,
        "Total Verified": item.verified,
        Fresh: item.fresh,
        "V Under Review":item.v_under_review,
        "Not Interested": item.v_not_interested,
        "Callback":item.callback,
        "Follow Up":item.follow_up,
        "V Booking Done":item.v_booking_done,
        "V Follow Up":item.v_follow_up,
        "V Hold":item.v_hold,
        "V Interested":item.v_interested,
        "V Not Available":item.v_not_available,
        "V Not Interested":item.v_not_interested,
        "V Not Responding":item.v_not_responding,
        "V Sv Done":item.v_sv_done,
        "V Sv Drop":item.v_sv_drop,
        "Wrong Number":item.wrong_number,
         //
         "Interested": item.interested,
         "Not Responding": item.not_responding,
         "Not Available": item.not_available,
         "Contacted": item.contacted,
         "Site Visit": item.site_visit,
         "Closed/Won": item.closed_won,
         "Appointment Proposed": item.appointment_proposed,

      }));
      this.fbCampaign = transformedFBCampaignData;
    
     
      //Google Campaign 
      const transformedGoogleCampaignData: any[] = this.googleCampaign.map((item) => ({
        "Campaign Name": item.google_campaign_name,
        "Google Ad Group Name": item.google_adgroup_name,
        "Google AD Name":item.google_ad_name,
        "Keyword":item.google_keyword_name,

        "Total Leads":item.lead_count,
        "Total Verified": item.verified,
        Fresh: item.fresh,
        "V Under Review":item.v_under_review,
        "Not Interested": item.v_not_interested,
        "Callback":item.callback,
        "Follow Up":item.follow_up,
        "V Booking Done":item.v_booking_done,
        "V Follow Up":item.v_follow_up,
        "V Hold":item.v_hold,
        "V Interested":item.v_interested,
        "V Not Available":item.v_not_available,
        "V Not Interested":item.v_not_interested,
        "V Not Responding":item.v_not_responding,
        "V Sv Done":item.v_sv_done,
        "V Sv Drop":item.v_sv_drop,
        "Wrong Number":item.wrong_number,
         //
         "Interested": item.interested,
         "Not Responding": item.not_responding,
         "Not Available": item.not_available,
         "Contacted": item.contacted,
         "Site Visit": item.site_visit,
         "Closed/Won": item.closed_won,
         "Appointment Proposed": item.appointment_proposed,

      }));
      this.googleCampaign = transformedGoogleCampaignData;
      //UTM Campaign
      // console.log(this.utmCampaign)
      const transformedUTMCampaignData: any[] = this.utmCampaign.map((item) => ({
        "UTM Source":item.utm_source,
        "UTM Medium":item.utm_medium,
        "Campaign Name": item.utm_campaign,
        "UTM Content":item.utm_content,
        "UTM Term": item.utm_term,

        "Total Leads":item.lead_count,
        "Total Verified": item.verified,
        Fresh: item.fresh,
        "V Under Review":item.v_under_review,
        "Not Interested": item.not_interested,
        "Callback":item.callback,
        "Follow Up":item.follow_up,
        "V Booking Done":item.v_booking_done,
        "V Follow Up":item.v_follow_up,
        "V Hold":item.v_hold,
        "V Interested":item.v_interested,
        "V Not Available":item.v_not_available,
        "V Not Interested":item.v_not_interested,
        "V Not Responding":item.v_not_responding,
        "V Sv Done":item.v_sv_done,
        "V Sv Drop":item.v_sv_drop,
        "Wrong Number":item.wrong_number,

        //
        "Interested": item.interested,
        "Not Responding": item.not_responding,
        "Not Available": item.not_available,
        "Contacted": item.contacted,
        "Site Visit": item.site_visit,
        "Closed/Won": item.closed_won,
        "Appointment Proposed": item.appointment_proposed,

      })); 
      this.utmCampaign = transformedUTMCampaignData;
      ////////////////////////////////////////////End of transfromation of Data///////////////////////////// 
    
      this.isFilter = true
      // console.log(this.week)
      //console.log(data)

      var pivot = new WebDataRocks({
        container: this.pivotContainer.nativeElement,
        // width:800,
        height: 400,
        // toolbar: true,
        report: {
          "formats": [
            {
                "name": "",
                // "decimalPlaces": 2,
                "thousandsSeparator":","
                // "currencySymbol": "$"
            }
        ],
          dataSource: {
            data: this.fbCampaign
          },

          options: {
            grid: {
              type: "classic",
              showTotals: "on",
              // showGrandTotals: "off", 
            }
          },
          
        
          "slice": {
            "rows": [
              { "uniqueName": "Campaign Name" },
              { "uniqueName": "FB Adset Name" },
              { "uniqueName": "FB AD Name" },
              

            ],

            "measures": [
             
              
              {
                "uniqueName": "Total Leads",
                "aggregation":"sum",
                // "caption":"Fresh"
              },
            {
              "uniqueName": "Fresh",
              "aggregation":"sum",
              // "caption":"Fresh"
            },
            {
              "uniqueName": "V Under Review",
              "aggregation":"sum",
              // "caption":"Fresh"
            },
            {
              "uniqueName": "Total Verified",
              "aggregation":"sum",
              // "caption":"Total Verified"
            },
           
            {
              "uniqueName": "Not Interested",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Callback",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Follow Up",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Booking Done",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Follow Up",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Hold",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Interested",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Available",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Interested",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Not Responding",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Sv Done",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "V Sv Drop",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Wrong Number",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },


            {
              "uniqueName": "Interested",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Not Responding",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Not Available",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Contacted",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Site Visit",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Closed/Won",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
            {
              "uniqueName": "Appointment Proposed",
              "aggregation":"sum",
              // "caption":"Not Interested"
            },
          
           
          

            ],
            

          },
          
         
          
        },
        customizeCell: (cell, data) => {
          if (data.isGrandTotalColumn || data.isGrandTotalRow) {
            if (data.label) {
              cell.text = data.label.replace('Total Sum of ', '');
            }
          }
        },
       
      });

     
//Google Campaign

var pivot = new WebDataRocks({
  container: this.weekpivotContainer.nativeElement,
  // width:800,
  height: 400,
  // toolbar: true,
  report: {
    "formats": [
      {
          "name": "",
          // "decimalPlaces": 2,
          "thousandsSeparator":","
          // "currencySymbol": "$"
      }
  ],
    dataSource: {
      data: this.googleCampaign
    },

    options: {
      grid: {
        type: "classic",
        showTotals: "on",
        // showGrandTotals: "off", 
      }
    },
    
  
    "slice": {
      "rows": [
        { "uniqueName": "Campaign Name" },
        { "uniqueName": "Google Ad Group Name" },
        { "uniqueName": "Google AD Name" },
        { "uniqueName": "Keyword" },

        

      ],

      "measures": [
       
        {
          "uniqueName": "Total Leads",
          "aggregation":"sum",
          // "caption":"Fresh"
        },
      {
        "uniqueName": "Fresh",
        "aggregation":"sum",
        // "caption":"Fresh"
      },
      {
        "uniqueName": "V Under Review",
        "aggregation":"sum",
        // "caption":"Fresh"
      },
      {
        "uniqueName": "Total Verified",
        "aggregation":"sum",
        // "caption":"Total Verified"
      },
     
      {
        "uniqueName": "Not Interested",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Callback",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Follow Up",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Booking Done",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Follow Up",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Hold",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Interested",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Not Available",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Not Interested",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Not Responding",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Sv Done",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Sv Drop",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Wrong Number",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Interested",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Not Responding",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Not Available",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Contacted",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Site Visit",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Closed/Won",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Appointment Proposed",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
    
     
      
     
    

      ],
      

    },
    
   
    
  },
  customizeCell: (cell, data) => {
    if (data.isGrandTotalColumn || data.isGrandTotalRow) {
      if (data.label) {
        cell.text = data.label.replace('Total Sum of ', '');
      }
    }
  },

});

//UTM Campaign

var pivot2 = new WebDataRocks({
  container: this.utmpivotContainer.nativeElement,
  // width:800,
  height: 400,
  // toolbar: true,
  report: {
    "formats": [
      {
          "name": "",
          // "decimalPlaces": 2,
          "thousandsSeparator":","
          // "currencySymbol": "$"
      }
  ],
    dataSource: {
      data: this.utmCampaign
    },

    options: {
      grid: {
        type: "classic",
        showTotals: "on",
        // showGrandTotals: "off", 
      }
    },
    
  
    "slice": {
      "rows": [
        { "uniqueName": "UTM Source" },
        { "uniqueName": "UTM Medium" },
        { "uniqueName": "Campaign Name" },
        { "uniqueName": "UTM Content" },
        { "uniqueName": "UTM Term" },

      ],

      "measures": [
       
        {
          "uniqueName": "Total Leads",
          "aggregation":"sum",
          // "caption":"Fresh"
        },
      {
        "uniqueName": "Fresh",
        "aggregation":"sum",
        // "caption":"Fresh"
      },
      {
        "uniqueName": "V Under Review",
        "aggregation":"sum",
        // "caption":"Fresh"
      },
      {
        "uniqueName": "Total Verified",
        "aggregation":"sum",
        // "caption":"Total Verified"
      },
     
      {
        "uniqueName": "Not Interested",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Callback",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Follow Up",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Booking Done",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Follow Up",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Hold",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Interested",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Not Available",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Not Interested",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Not Responding",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Sv Done",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "V Sv Drop",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Wrong Number",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      
      {
        "uniqueName": "Interested",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Not Responding",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Not Available",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Contacted",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Site Visit",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Closed/Won",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
      {
        "uniqueName": "Appointment Proposed",
        "aggregation":"sum",
        // "caption":"Not Interested"
      },
    
      
     
    

      ],
      

    },
    
   
    
  },
  customizeCell: (cell, data) => {
    if (data.isGrandTotalColumn || data.isGrandTotalRow) {
      if (data.label) {
        cell.text = data.label.replace('Total Sum of ', '');
      }
    }
  },
 
});

//
      if (this.googleCampaign == '') {
        this.shouldRenderSecondElement = true;
      }
      if (this.fbCampaign == '') {
        this.shouldRenderProjectElement = true;
      }
      if(this.utmCampaign == ''){
      this.shouldRenderThirdElement = true;
      }
      this.load = true
      // console.log(data)
    })
  }

  setFilter() {

    this.filterForm = this._fb.group({
      dateRange: ['',Validators.required],
      dateRangeVendorModified:["",Validators.required],
      project: [''],
   
    })
   
  
    // console.log(this.filterForm['client'])
  }

  filterSubmit() {

    this.isFilter = true;
    this.noFilter = false;
    if (this.filterForm.invalid) {
      return false
    }

    // console.log(this.filterForm.value)
    // let d1 = [this.filterForm.value['dateRange'].formatted.split(" - ")[0], this.filterForm.value['dateRange'].formatted.split(" - ")[1]]
    // let d2 = [this.filterForm.value['dateRangeVendorModified'].formatted.split(" - ")[0], this.filterForm.value['dateRangeVendorModified'].formatted.split(" - ")[1]]
    this.campaignReport();

    // console.log(d1)
  }




  getProjects() {
    this.serverService.projectsList(this.authToken).subscribe(data => {
      this.projects = data
    }, err => {
      this.clipBoardService.checkServerError(err, this.authToken)
    }
    )
  }

 


  clear() {
    this.filterForm.reset()
    this.filterForm.get('dateRange').enable();
    this.filterForm.get('dateRangeVendorModified').enable();
    this.noFilter = true;
    this.isFilter = false;
    this.load = false
  }

  generateExcelFileFbCampaign() {
  
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.fbCampaign);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Define the file name for the Excel file
    const fileName = 'facebook_campaign_report.xlsx';
  
    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }
  generateExcelFileGoogleCampaign() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.googleCampaign);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Define the file name for the Excel file
    const fileName = 'google_campaign_report.xlsx';
  
    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }
  generateExcelUtmCampaign() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.utmCampaign);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
    // Define the file name for the Excel file
    const fileName = 'utm_campaign_report.xlsx';
  
    // Save the Excel file
    XLSX.writeFile(wb, fileName);
  }
  //Count function
  calculateTotalCounts(data) {
    let totalCold = 0;
    let totalFresh = 0;
    let totalOthers = 0;
  
    data.forEach(item => {
      if (item.lead_state === 'Cold') {
        totalCold += item.total_leads;
      } else if (item.lead_state === 'Fresh') {
        totalFresh += item.total_leads;
      } else {
        totalOthers += item.total_leads;
      }
    });
  
    return [
      { lead_state: 'Cold', total_leads: totalCold },
      { lead_state: 'Fresh', total_leads: totalFresh },
      { lead_state: 'Others', total_leads: totalOthers },
    ];
  }
  date1Change(event:any){
      const date1Control = this.filterForm.get('dateRange');
      const date2Control = this.filterForm.get('dateRangeVendorModified');
      if (date1Control) {
      this.filterForm.controls.dateRange.clearValidators()
        date2Control.disable();
      }
      if(event["beginJsDate"] == null && event["endJsDate"] == null){
        date2Control.enable();
      }
      date2Control.updateValueAndValidity();
  }
  date2Change(event:any){
      const date1Control = this.filterForm.get('dateRange');
      const date2Control = this.filterForm.get('dateRangeVendorModified');
      if (date2Control) {
        this.filterForm.controls.dateRangeVendorModified.clearValidators()
        date1Control.disable();
      }
      if(event["beginJsDate"] == null && event["endJsDate"] == null){
        date1Control.enable();
      }
      date1Control.updateValueAndValidity();
  }
  filterDate(event:any){
    // console.log(event.srcElement
    //   .defaultValue)
    // this.filterText = event.srcElement.defaultValue;
    if(event.srcElement.defaultValue == 'vendor_modified'){
      this.filterText = "Last Vendor Modified Date Range"
    }
    else
    {
      this.filterText = "Lead Creation Date Range"
    }
    
  }
 
}
